import {requestData} from 'services'
import {GiftShopGetCartCountResponse} from 'types'
import {GIFT_SHOP_CACHE_TTL_MS} from 'consts'
import {reduxSelector, reduxUpdateDispatcher} from 'lib/redux'

let lastFetch = 0
let activeFetchPromise: Promise<GiftShopGetCartCountResponse | null> | null = null

function getMapReduxCache(): GiftShopGetCartCountResponse | null {
  const state = reduxSelector('cart')
  if (state.cart_count === undefined) {
    return {
      total_item: 0,
    }
  }
  return {
    total_item: state.cart_count,
  }
}

function isCacheValid() {
  const {cart_count} = reduxSelector('cart')
  const isDataMissing = cart_count === undefined
  const isCacheExpired = Date.now() - lastFetch > GIFT_SHOP_CACHE_TTL_MS

  return !isCacheExpired && !isDataMissing
}

async function fetchData(): Promise<GiftShopGetCartCountResponse | null> {
  try {
    const response = await requestData('giftshop_get_cart_count')

    if (typeof response !== 'string' && response.status === 200) {
      lastFetch = Date.now()
      const {result} = response.data

      reduxUpdateDispatcher('cart', {
        cart_count: result.total_item,
      })
      return result
    }
  } catch (e) {
    console.error(e)
  } finally {
    activeFetchPromise = null
  }

  return getMapReduxCache()
}

export async function handleGiftshopGetCartCount(
  forceRequest = false,
): Promise<GiftShopGetCartCountResponse | null> {
  if (activeFetchPromise) return activeFetchPromise

  if (forceRequest || !isCacheValid()) {
    activeFetchPromise = fetchData()

    return activeFetchPromise
  }

  return getMapReduxCache()
}

export function handleGiftShopInvalidateCartCount() {
  lastFetch = 0
  activeFetchPromise = null
}
